import { GetRequestOptions } from "./grunt";

const getPth=process.env.REACT_APP_GRUNT_API+"/drzava";
const getDrzaveUvozaPth=process.env.REACT_APP_GRUNT_API+"/drzava/uvoz";
const getDrzaveIzvozaPth=process.env.REACT_APP_GRUNT_API+"/drzava/izvoz";
const StatusOk={status:200};

class Drzava {
    constructor (id=0,sifra="",naziv="") {
        this.id=id;
        this.sifra=sifra;
        this.naziv=naziv;
    }
}


const getDrzave=async()=>{
    let _pth=getPth;
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getDrzaveById=async({drzave=[]})=>{
    let _pth=getPth+"/drzave";
    let _d=""
    if (drzave.length>0) {
        drzave.forEach((item,index)=>{
            if (index===0) {
                _d=_d+`${String(item)}`;    
            } else {
                _d=_d+`|${String(item)}`;
            }
            
        })
    }
    if (_d!=="") {
        _pth+="?drzaveid="+_d;
    }
    try {
        const r = await fetch(_pth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getDrzaveUvoza=async()=>{
    
    try {
        const r = await fetch(getDrzaveUvozaPth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const getDrzaveIzvoza=async()=>{
    
    try {
        const r = await fetch(getDrzaveIzvozaPth, GetRequestOptions("GET"));    
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;               
        }
        
    } catch (ex) {
        return {code: ex.code, message: "Greška kod dohvata podataka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const addDrzava=async (drzava)=>{
    try {
        let reqopt=GetRequestOptions("POST");
        reqopt.body=JSON.stringify(drzava);
        const r=await fetch(getPth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod pohrane podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

const updateDrzava=async (drzava)=>{
    try {
        let reqopt=GetRequestOptions("PUT");
        reqopt.body=JSON.stringify(drzava);
        const r=await fetch(getPth,reqopt);
        const StatusOk={status:200};
        const res=await r.json();
        if (r.status===200) {
            StatusOk.res=res;
            return StatusOk;
        } else {
            return res;
        }
    } catch (ex) {
        return {code: ex.code, message: "Greška kod ispravka podatka. " + ex.message, status: ex.status, name: ex.name};
    }
}

export {getDrzave, addDrzava, updateDrzava, Drzava, getDrzaveUvoza,getDrzaveIzvoza,getDrzaveById};